/* import __COLOCATED_TEMPLATE__ from './call-quality-warning-banner.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    onViewDetails: () => void;
  };
}

const CallQualityWarningBanner = templateOnlyComponent<Signature>();
export default CallQualityWarningBanner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Calling::CallQualityWarningBanner': typeof CallQualityWarningBanner;
    'inbox2/calling/call-quality-warning-banner': typeof CallQualityWarningBanner;
  }
}
